<template>
    <div>
        <mdb-navbar expand="large" dark color="info-color-dark">
            <mdb-navbar-brand to="/admin">
                Administration
            </mdb-navbar-brand>
            <mdb-navbar-toggler>
                <mdb-navbar-nav>
                    <mdb-nav-item to="/adminuser">Utilisateurs</mdb-nav-item>
                    <!--
                    <mdb-nav-item to="/admincategory">Catégories</mdb-nav-item>
                    <mdb-nav-item to="/adminvideo">Vidéos</mdb-nav-item>
                    -->
                </mdb-navbar-nav>
            </mdb-navbar-toggler>
        </mdb-navbar>
    </div>
</template>

<script>
    import {
        mdbNavbar,
        mdbNavbarBrand,
        mdbNavbarToggler,
        mdbNavItem,
        mdbNavbarNav,
    } from 'mdbvue';

    export default {
        name: 'Adminheader',
        components: {
            mdbNavbar,
            mdbNavbarBrand,
            mdbNavbarToggler,
            mdbNavItem,
            mdbNavbarNav,
        },
    };
</script>
